import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { SelectDirectionType, SelectUnitMeasurement } from "../../../../components/selects";
import { EntTypeProduct } from "../../../../models/handBooks/typeProduct";
import SelectGeneralTypeOfCatecory from "../../../../components/selects/SelectGeneralTypeOfCatecory";

enum FormField {
    nameKy,
    alias,
    unitMeasurementId,
    directionIds,
    nameRu,
    productCategoryId
}
interface IProps {
    show: boolean;
    typeProduct: EntTypeProduct;
    onHide: () => void;
    onSubmit: (pos: EntTypeProduct) => Promise<boolean>;
}

export const AddTypeProductModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);


    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);


    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.unitMeasurementId, value: props.typeProduct.unitMeasurement?.id },
            { name: FormField.nameKy, value: props.typeProduct.nameKy },
            { name: FormField.nameRu, value: props.typeProduct.nameRu },
            { name: FormField.directionIds, value: props.typeProduct.directionIds || [] },
            { name: FormField.productCategoryId, value: props.typeProduct.productCategoryId },
        ]);
    }

    const setEntityFromFields = (): EntTypeProduct => {
        let typeProduct = _.cloneDeep(props.typeProduct);
        typeProduct.unitMeasurementId = form.getFieldValue(FormField.unitMeasurementId);
        typeProduct.nameKy = form.getFieldValue(FormField.nameKy);
        typeProduct.nameRu = form.getFieldValue(FormField.nameRu);
        typeProduct.directionIds = form.getFieldValue(FormField.directionIds);
        typeProduct.productCategoryId = form.getFieldValue(FormField.productCategoryId);
        return typeProduct;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);

            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={props.typeProduct.id === 0 ? t('handbooks.type_product.add_type_product') : t('handbooks.type_product.edit_type_product')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >

                    <Form.Item
                        label={t('general.nameKy')}
                        name={FormField.nameKy}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('general.nameRu')}
                        name={FormField.nameRu}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('titles.direction')}
                        name={FormField.directionIds}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                            <SelectDirectionType mode="multiple" />
                    </Form.Item>
                    <Form.Item
                        label={t('Категоря продукта111')}
                        name={FormField.productCategoryId}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <SelectGeneralTypeOfCatecory />
                    </Form.Item>
                    <Form.Item
                        label={t('titles.units_of_measurement')}
                        name={FormField.unitMeasurementId}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <SelectUnitMeasurement />
                    </Form.Item>
                </Form>
            </DraggableModal>

        </>

    )
}
